import React from "react";
import { SelectInput, useDataProvider } from "react-admin";

export const CustomerSelect = ({ source = "ownerCode", optionText = "ownerCode", optionValue = "id", ...props }) => {
  const dataProvider = useDataProvider();
  const [customers, setCustomers] = React.useState<any>([]);

  React.useEffect(() => {
    getCustomers();
  }, []);

  const getCustomers = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "ASC" },
        filter: {},
      })
      .then(result => {
        if (result?.data?.length > 0) {
          setCustomers(result.data);
        } else {
          setCustomers([]);
        }
      });
  };

  return (
    <SelectInput
      fullWidth
      source={source}
      choices={customers}
      optionText={optionText}
      optionValue={optionValue}
      {...props}
    />
  );
};
export default CustomerSelect;
